import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import {
  TbClockBolt,
  TbChartHistogram,
  TbBrain,
  TbArrowsShuffle,
} from "react-icons/tb";

const benefits = [
  {
    icon: <TbClockBolt size={32} />,
    title: "Respondé en tiempo real",
    description:
      "Automatizamos alertas y detección de fallas para que corrijas tus tiempos muertos y scrap al instante, sin esperar reportes que llegan tarde.",
    accent: "#7c3aed",
  },
  {
    icon: <TbChartHistogram size={32} />,
    title: "Decisiones con datos",
    description:
      "OEE, FTQ, paradas, calidad, logística, mantenimiento, recursos humanos y más. Todo visible en dashboards en vivo. Sin intuición."
      
      
      ,
    accent: "#2563eb",
  },
  {
    icon: <TbBrain size={32} />,
    title: "Operación inteligente",
    description:
      "Simulá, visualizá y optimizá procesos con un gemelo digital de tu planta antes de hacer cambios.",
    accent: "#d97706",
  },
  {
    icon: <TbArrowsShuffle size={32} />,
    title: "Todo integrado",
    description:
      "Producción, calidad, mantenimiento, RRHH, logística, finanzas y administración trabajando en un solo ecosistema.",
    accent: "#059669",
  },
];

const TwinexaBenefits = () => (
  <section id="clientes" style={{ padding: "5rem 0" }}>
    <div className="container">

      {/* Header */}
      <Slide direction="up" duration={700} triggerOnce>
        <div className="text-center mb-5">
          <span className="eco-badge mb-4">Por qué Twinexa</span>
          <h2 className="eco-main-title text-white">
            Arquitectura digital para operaciones{" "}
            <span className="highlight">que necesitan escalar.</span>
          </h2>
          <p className="eco-main-sub text-white-50">
            Cada módulo resuelve un problema específico. Juntos, transforman tu operación.
          </p>
        </div>
      </Slide>

      {/* Cards grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "1.25rem",
          alignItems: "stretch",
        }}
      >
        {benefits.map((item, idx) => (
          <Fade direction="up" triggerOnce duration={650} delay={100 + idx * 100} key={idx} style={{ height: "100%" }}>
            <div
              style={{
                height: "100%",
                background: "rgba(255,255,255,0.03)",
                border: `1px solid rgba(255,255,255,0.07)`,
                borderRadius: "1rem",
                padding: "1.75rem 1.5rem",
                display: "flex",
                flexDirection: "column",
                gap: "0.85rem",
                transition: "border-color 0.25s ease, background 0.25s ease",
                boxSizing: "border-box",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = item.accent + "55";
                e.currentTarget.style.background = item.accent + "0d";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)";
                e.currentTarget.style.background = "rgba(255,255,255,0.03)";
              }}
            >
              {/* Icon */}
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: "0.75rem",
                  background: item.accent + "18",
                  border: `1px solid ${item.accent}33`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: item.accent,
                }}
              >
                {item.icon}
              </div>

              {/* Text */}
              <h3
                style={{
                  color: "#fff",
                  fontSize: "1rem",
                  fontWeight: 700,
                  margin: 0,
                  lineHeight: 1.35,
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  color: "rgba(255,255,255,0.5)",
                  fontSize: "0.85rem",
                  margin: 0,
                  lineHeight: 1.6,
                }}
              >
                {item.description}
              </p>
            </div>
          </Fade>
        ))}
      </div>
    </div>
  </section>
);

export default TwinexaBenefits;

